module.exports = __webpack_public_path__ + "img/36_35.0f6e91bc.png";